export const actions = {
  nuxtServerInit ({ commit, dispatch, state }) {
    commit('user/setToken', this.$cookiz.get('auth_token'))

    const requests = []

    if (state.user.token) {
      requests.push(dispatch('user/fetchUser'))
    }

    requests.push(dispatch('games/fetchGames'))

    dispatch('marketplace/fetchCurrencies')

    return Promise.all(requests)
  }
}
